import { Button } from "antd"
import { DownloadOutlined } from "@ant-design/icons"
import PropTypes from "prop-types"

DownloadButton.propTypes = {
  children: PropTypes.node,
  outlined: PropTypes.bool,
  style: PropTypes.object
}

export function DownloadButton ({ children, outlined, style, ...props }) {
  if (outlined) {
    style = { backgroundColor: "#612f5eb3", color: "white", ...style }
  }
  return (
    <Button style={style} {...props}>
      <DownloadOutlined /> {children}
    </Button>
  )
}
